// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"4967131b","195":"3f2607f4","232":"7dad452b","580":"2bd23804","645":"14712e9d","814":"4b68a689"}[chunkId] + ".chunk.js";
};